export const getCDNUrl = (url: string) => {
  return url
  // return import.meta.env.NODE_ENV === 'production'
  //   ? url
  //   : url.replace(
  //       'https://not-platform.fra1.cdn.digitaloceanspaces.com',
  //       'http://localhost:5173'
  //     )
}
